import domExists from '../dom/domExists';
function handleError(error, options) {
  if (error) {
    console.error(error);
  } else {
    console.error('handleError called with empty error.');
  }
  if (domExists()) {
    const rg4js = window.rg4js;
    const newrelic = window.newrelic;
    if (typeof rg4js === 'function') {
      rg4js('send', {
        error,
        tags: options === null || options === void 0 ? void 0 : options.tags,
        customData: options === null || options === void 0 ? void 0 : options.customData
      });
    }
    if (typeof newrelic !== 'undefined' && typeof newrelic.noticeError === 'function') {
      newrelic.noticeError(error);
    }
  }
}
export default handleError;